import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import MovieGrid from './components/MovieGrid';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import { hotRanking, latestUpdates } from '@/mocks/movies';
import { Link } from 'react-router-dom';
import { faqList } from '@/mocks/articles';

export default function Home() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '桃花影院',
    url: 'https://taohua-cinema.com',
    description: '桃花影院提供免费在线电影院，所有电影电视剧高清不缓冲免费观看，涵盖最新电视剧全集、热门电影、免费电影网站，不花钱看大片，永久免费无需会员。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://taohua-cinema.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />

      <Navbar />

      <main>
        <HeroBanner />

        <MovieGrid />

        <HotRanking movies={hotRanking} />

        <LatestUpdates movies={latestUpdates} />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
                <i className="ri-question-answer-line text-primary-500 text-lg"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                常见问题
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {faqList.map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-50 rounded-lg p-5 cursor-pointer border border-background-200/70 hover:border-primary-200 transition-colors"
                >
                  <summary className="flex items-center justify-between gap-3 text-sm font-semibold text-foreground-900 marker:content-none">
                    <span>{faq.question}</span>
                    <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg"></i>
                    </div>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              永久免费，精彩不断
            </h2>
            <p className="text-foreground-500 mb-6 max-w-2xl mx-auto leading-relaxed">
              桃花影院致力于为广大影视爱好者提供最优质的免费观影体验。无论是最新热映大片，还是经典老片回顾，无论是国产精品还是海外佳作，这里都有你想要的精彩内容。无需注册，无需付费，打开即看，畅享高清。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}